import { EyeIcon } from '@heroicons/react/24/solid';
import React, { useEffect, useState } from 'react'
import { Link, useLoaderData } from 'react-router-dom';
import { LoadingData } from '../../components/Loading';
import Pagination from '../../components/Pagination';

export default function Cases() {
    const [data, setData] = useState([]);
    const [cases, setCases] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const serverData = useLoaderData()

    useEffect(() => {
        setData(serverData)
        return () => { }
    }, [serverData])

    useEffect(() => {
        if (data && data.docs) {
            setPage(data?.page)
            setCases(data?.docs);
        }
    }, [data])
    return (
        <div className="w-full">
            <h4 className="text-xl font-fira font-semibold capitalize">Cases</h4>
            <div className="mt-6 bg-white pt-3 rounded-lg">
                <div className="">
                    <div className="px-4 mb-4 flex justify-between items-center">
                        <h4 className="text-sm font-semibold font-fira text-gray-800">All Cases</h4>
                        <h4 className="text-xs font-semibold text-gray-800">Current Page {page}</h4>
                    </div>
                    <div className="w-full overflow-x-scroll">
                        <table className="min-w-max w-full table-auto">
                            <thead className="text-xs font-fira bg-gray-200 rounded-t-lg">
                                <tr>
                                    <th className="py-3 px-8 text-left">ID</th>
                                    <th className="py-3 px-8 text-left">Mediator</th>
                                    <th className="py-4 px-8 text-left">Claimants</th>
                                    <th className="py-4 px-8 text-left">Defendants</th>
                                    <th className="py-4 px-8 text-left">Category</th>
                                    <th className="py-4 px-8 text-left">Status</th>
                                    <th className="py-4 px-8 text-left"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {cases.map(cr => (<tr key={cr._id} className="border-b-2 font-semibold text-xs border-gray-200 hover:bg-gray-100">
                                    <td className='py-4 px-8 text-left whitespace-nowrap'>{cr.uid}</td>
                                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                                        {(cr.mediator && cr.mediator !== null) && <div className="flex gap-2 items-center justify-center">
                                            <img src={cr.mediator.avatar} alt="" className="w-8 h-8 rounded-full border-2 border-gray-200" />
                                            <div>
                                                <h4 className="text-xs font-semibold">{cr.mediator.name}</h4>
                                                <a className="text-xs text-blue-900" href={`mailto:${cr.mediator.email}`}>{cr.mediator.email}</a>
                                            </div>
                                        </div>}
                                        {(!cr.mediator || cr.mediator === null) && <span>No Mediator</span>}
                                    </td>
                                    <td className='py-4 px-8 text-left whitespace-nowrap'>
                                        <div className="flex items-center justify-center">
                                            {cr.claimants.map((rcc) => {
                                                let index = cr.claimants.findIndex((rci) => rci._id === rcc._id);
                                                return <img key={rcc._id} title={rcc.name} className={`w-8 h-8 cursor-pointer rounded-full border-2 border-gray-200 transform hover:scale-125 ${index > 0 ? '-ml-3' : ''}`} src={rcc.avatar} alt="" />
                                            })}
                                        </div>
                                    </td>
                                    <td className='py-4 px-8 text-left whitespace-nowrap'>
                                        <div className="flex items-center justify-center">
                                            {Array.from(cr.defendants).map((rcd) => {
                                                let index = cr.defendants.findIndex((rci) => rci._id === rcd._id);
                                                return (<img key={rcd._id} title={rcd.name} className={`w-8 h-8 cursor-pointer rounded-full border-2 border-gray-200 transform hover:scale-125 ${index > 0 ? '-ml-3' : ''}`} src={rcd.avatar} alt="" />)
                                            })}
                                        </div>
                                    </td>
                                    <td className='py-4 px-8 text-left whitespace-nowrap'>
                                        <span>{cr.category}</span>
                                    </td>
                                    <td className='py-4 px-8 text-left whitespace-nowrap'>
                                        <span>{cr.status}</span>
                                    </td>
                                    <td className='py-4 px-8 text-left whitespace-nowrap'>
                                        <Link to={`/admin/case-detail/${cr._id}`} className='flex gap-1 hover:text-blue-900 items-center'>
                                            <span>
                                                <EyeIcon className="h-4 w-4" />
                                            </span>
                                            <span className='whitespace-nowrap'>See Detail</span>
                                        </Link>
                                    </td>
                                </tr>))}
                            </tbody>
                        </table>
                    </div>
                    {(cases.length < 1 && !loading) && <div className="no-case flex py-8 px-6 flex-col justify-center gap-6">
                        <div className="text-center">
                            <h4 className="font-semibold font-fira text-lg">No Case Resolution Record</h4>
                        </div>
                    </div>}
                    {loading && <div className="mt-10">
                        <LoadingData message="Loading Transactions..." />
                    </div>}
                </div>
            </div>
            {<Pagination currentData={data} setData={setData} setLoading={setLoading} />}
        </div>
    )
}
